import Vue from "vue";
import Vuex from "vuex";

const jwt = require("jsonwebtoken");

Vue.use(Vuex);

const getColor = async (state, id) => {
  const query = `{color(id:"${id}") { id code hex formula { id multiplier createdAt materials { amount material { name hex }} history { id multiplier createdAt materials { amount material {name hex }} }} } }`;
  const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${state.state.token}`,
    },
    redirect: "follow",
    body: JSON.stringify({ query }),
  });

  return await response.json();
};

const getFavFormula = async (state, formula) => {
  const query = `{formula(id: "${formula}") {materials {amount material {id name hex}}}}`;

  console.log("getFavFormula(): query", query);

  const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${state.token}`,
    },
    redirect: "follow",
    body: JSON.stringify({ query }),
  });

  const results = await response.json();
  console.log("getFavFormula(): results", results);
  return (
    results &&
    results.data &&
    results.data.formula &&
    results.data.formula.materials
  );
};

export default new Vuex.Store({
  state: {
    currentColor: {},
    allColors: [],
    currentFavorite: {},
    userFavorites: [],
    token: localStorage.getItem("access_token") || null,
  },
  mutations: {
    setCurrentColor: (state, payload) => {
      state.currentColor = payload;
    },
    setCurrentFavorite: (state, payload) => {
      state.currentFavorite = payload;
    },
    setAllColors: (state, payload) => {
      state.allColors = payload.sort(function (a, b) {
        const textA = a.code.toUpperCase();
        const textB = b.code.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    setUserFavorites: (state, payload) => {
      state.userFavorites = payload.sort(function (a, b) {
        const textA = a.color.code.toUpperCase();
        const textB = b.color.code.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      getFavFormula(state, state.userFavorites[0].formula.id)
        .then((result) => {
          console.log("setUserFavorites() > getFavFormula() > result", result);
          console.log("setUserFavorites() > getFavFormula() > state", state);
          state.currentFavorite = {
            ...state.userFavorites[0],
            materials: result,
          };
          console.log(
            "setUserFavorites() > getFavFormula() > state.currentFavorite",
            state.currentFavorite,
          );
        })
        .catch((e) => console.error(e));
    },
    retrieveToken: (state, token) => {
      state.token = token;
      //console.log('SET_TOKEN', token);
    },
    destroyToken: (state) => {
      state.token = null;
    },
  },
  actions: {
    destroyToke: async (state) => {
      localStorage.removeItem("access_token");
      state.commit("destroyToken");
    },
    registerUser: async (state, credentials) => {
      const response = await fetch(
        `${process.env.VUE_APP_SERVER_ROOT}auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.state.token}`,
          },
          redirect: "follow",
          body: JSON.stringify({
            username: credentials.username,
            password: credentials.password,
          }),
        },
      );

      if (response.status === 200) {
        const data = await response.json();
        state.commit("retrieveToken", data.token);
        localStorage.setItem("access_token", data.token);
        return "SUCCESS";
      } else console.log("ERROR", response);
      return "ERROR";
    },
    resetPassword: async (state, credentials) => {
      const response = await fetch(
        `${process.env.VUE_APP_SERVER_ROOT}auth/fnreset`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${credentials.token}`,
          },
          redirect: "follow",
          body: JSON.stringify({
            username: credentials.username,
            password: credentials.password,
          }),
        },
      );

      if (response.status === 200) {
        return "SUCCESS";
      } else console.log("ERROR", response);
      return "ERROR";
    },
    retrieveToken: async (state, credentials) => {
      const response = await fetch(
        `${process.env.VUE_APP_SERVER_ROOT}auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.state.token}`,
          },
          redirect: "follow",
          body: JSON.stringify({
            username: credentials.username,
            password: credentials.password,
          }),
        },
      );

      if (response.status === 200) {
        const data = await response.json();
        state.commit("retrieveToken", data.token);
        localStorage.setItem("access_token", data.token);
        return "SUCCESS";
      } else console.error("ERROR", response);
      return "ERROR";
    },
    searchColor: async (state, payload) => {
      const query = `{colorSearch(query: "${payload}") { id code hex name formula {createdAt} } }`;

      const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });

      return await response.json();
    },
    deleteColor: async (state, payload) => {
      const query = `mutation { deleteColor(code: "${payload}") { id }}`;

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    updateColor: async (state, payload) => {
      const query = `mutation {updateColor(id: "${payload.id}", name: "${payload.name}", hex: "${payload.hex}") { id code hex name } }`;

      const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });

      return await response.json();
    },
    setAllColors: async (state, payload) => {
      const query = `{colors { id code hex name } }`;
      const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      state.commit("setAllColors", data.data.colors);

      const color = await getColor(state, data.data.colors[0].id);
      state.commit("setCurrentColor", { ...color.data.color, grams: 100 });
    },
    setCurrentColor: async (state, payload) => {
      const data = await getColor(state, payload.id);
      state.commit("setCurrentColor", {
        ...data.data.color,
        grams: payload.grams,
      });
    },
submitPantoneRequest: async (state, payload) => {
  const query = `
    mutation RequestPantone($input: PantoneFormInput!) {
      requestPantone(input: $input) {
        name
        email
        code
        description
        status
        comments
      }
    }
  `;

  const response = await fetch(
    `${process.env.VUE_APP_SERVER_ROOT}api`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${state.state.token}`
      },
      redirect: 'follow',
      body: JSON.stringify({
        query,
        variables: {
          input: payload
        }
      })
    }
  );

  const result = await response.json();

  if (!response.ok) {
    throw new Error(
      `Pantone request failed with HTTP ${response.status}`
    );
  }

  if (result.errors?.length) {
    throw new Error(
      result.errors.map(error => error.message).join('; ')
    );
  }

  return result.data.requestPantone;
},
    submitResetRequest: async (state, payload) => {
      return await fetch(
        `${process.env.VUE_APP_SERVER_ROOT}auth/requestreset`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.state.token}`,
          },
          redirect: "follow",
          body: JSON.stringify(payload),
        },
      );
    },
    importCsv: async (state, payload) => {
      const query = `mutation {importFormulaCsv(csv: ${JSON.stringify(payload)})}`;

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    getAllMaterials: async (state, payload) => {
      const query = "{ materials { id hex name}}";

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    submitNewFormula: async (state, payload) => {
      const query = `mutation { createFormula(input: ${payload}) { id name}}`;

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    userFormulaEdit: async (state, payload) => {
      const query = `mutation { createUserFormula(input: ${payload}) { color{id} formula{id} version}}`;

      console.log("CREATE_USER_FORMULA", query);

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    getUserFavorites: async (state, paylod) => {
      const tokenData = jwt.decode(state.state.token);
      const query = `{user(id: "${tokenData.data.id}") {favoriteFormulas {color {id code name hex}formula {id multiplier}version customName}}}`;
      console.log("QUERY", query);
      const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      state.commit("setUserFavorites", data.data.user.favoriteFormulas);
    },
    getFavoriteFormula: async (state, payload) => {
      const query = `{formula(id: "${payload}") {materials {amount material {name hex}}}}`;

      const response = await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });

      return await response.json();
    },
    setCurrentFavorite: async (state, payload) => {
      console.log("setCurrentFavorite: state", state);
      console.log("setCurrentFavorite: payload", payload);

      const favFormula = await getFavFormula(state, payload.formula.id);
      console.log("setCurrentFavorite: favFormula", favFormula);
      if (favFormula) {
        const currentFavorite = { ...payload, materials: favFormula };
        console.log("setCurrentFavorite: currentFavorite", currentFavorite);
        state.commit("setCurrentFavorite", currentFavorite);
        return currentFavorite;
      }
      return null;
    },
    addNewFormulaFavorite: async (state, payload) => {
      const query = `mutation { addUserFavorite(input: {color: "${payload.color}", formula: "${payload.formula}", version: "${payload.version}"}){ version }}`;

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
    removeFormulaFavorite: async (state, payload) => {
      const query = `mutation { removeUserFavorite(input: {color: "${payload.color}", formula: "${payload.formula}", version: "${payload.version}"}){ version }}`;

      return await fetch(`${process.env.VUE_APP_SERVER_ROOT}api`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.state.token}`,
        },
        redirect: "follow",
        body: JSON.stringify({ query }),
      });
    },
  },
  modules: {},
  getters: {
    loggedIn: (state) => {
      if (!state.token) return false;

      const tokenData = jwt.decode(state.token);
      if (Date.now() >= tokenData.exp * 1000) {
        localStorage.removeItem("access_token");
        state.token = null;
        return false;
      }

      return true;
    },
    getCurrentColor: (state) => state.currentColor,
    getAllColors: (state) => state.allColors,
    getUserFavorites: (state) => state.userFavorites,
    getCurrentUserFavorite: (state) => state.currentFavorite,
    getUserToken: (state) => state.token,
  },
});
